import { Button, Typography } from 'components/atoms';
import styled from 'styled-components';

export const IconButtonWithLabel = styled(Button)`
  display: flex;
  align-items: center;
  gap: 10px;
  height: 44px;
`;

export const RecordsLabel = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  color: ${({ theme }) => theme.colours.darkToneInk};
`;

export const RecordsSummary = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(8)};
`;

export const DocumentErrorCount = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(4)};
  color: ${({ theme }) => theme.colours.redRampage};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
`;

export const DocumentsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: ${({ theme }) => theme.spacing(15)};

  .documentCard {
    flex: 1 1 auto;
    z-index: auto;
  }

  @media screen and (width > 1400px) {
    .documentCard {
      flex: 0 1 ${({ theme }) => theme.pxToRem(350)};
    }
  }
`;

export const DocumentsPlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 60px;
  color: ${({ theme }) => theme.colours.crowberryBlue};

  .title {
    margin-top: 24px;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 8px;
  }
`;

export const CbiSectionHeader = styled(Typography)(() => ({
  padding: '20px 0px',
  borderBottom: '1px solid #CACDCD',
}));

export const BulkUploadActionContainer = styled.div`
  > div {
    margin-bottom: 0;
  }
`;

export const PendingUploadDeleteButton = styled.button`
  cursor: pointer;
  padding: ${({ theme }) => theme.spacing(4)};
`;
